import styled from 'styled-components';
import { Match } from '@/types/api.types';

export const BracketContainer = styled.div`
    display: flex;
    gap: 30px;
    overflow-x: auto;
    padding: 20px 0;
`;

export const Round = styled.div`
    display: flex;
    flex-direction: column;
    gap: 15px;
    min-width: 250px;
`;

interface MatchBoxProps {
    status: Match['status'];
}

export const MatchBox = styled.div<MatchBoxProps>`
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    padding: 15px;
    background: white;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0 4px 8px rgba(0,0,0,0.15);
    }
`;

interface ParticipantProps {
    isWinner: boolean;
}

export const Participant = styled.div<ParticipantProps>`
    padding: 8px;
    margin: 4px 0;
    border-radius: 4px;
    background: ${props => props.isWinner ? '#f6ffed' : 'transparent'};
    ${props => props.isWinner && `
        font-weight: bold;
        color: #52c41a;
    `}
`;

export const MatchInfo = styled.div`
    font-size: 12px;
    color: #666;
    margin-top: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const CategorySelector = styled.div`
    margin-bottom: 20px;
`;




